// src/lib/uuid.ts
// Erzeugt ein UUID v4 — bewusst NICHT ueber newIdempotencyKey() aus lib/offline-queue.ts:
// dessen Rueckfallweg liefert `${Date.now()}-${random}`, und das Backend-Schema von
// POST /warehouse/fillup/request/ verlangt `request_id: z.string().uuid()`
// (src/modules/warehouse/types.ts) — ein Nicht-UUID wuerde dort mit 400 abgewiesen.
//
// `quelle` ist injizierbar, damit die Rueckfallwege testbar sind, ohne globale
// Objekte zu veraendern (crypto ist in manchen Umgebungen nicht beschreibbar).

export function neueUuid(quelle: Partial<Crypto> | undefined = globalThis.crypto): string {
  if (typeof quelle?.randomUUID === 'function') return quelle.randomUUID()

  const bytes = new Uint8Array(16)
  if (typeof quelle?.getRandomValues === 'function') {
    quelle.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256)
  }
  // Version (4) und Variante (RFC 4122) setzen — sonst ist es kein gueltiges v4.
  bytes[6] = ((bytes[6] as number) & 0x0f) | 0x40
  bytes[8] = ((bytes[8] as number) & 0x3f) | 0x80

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
  return [hex.slice(0, 8), hex.slice(8, 12), hex.slice(12, 16), hex.slice(16, 20), hex.slice(20)].join('-')
}
